module.exports = __webpack_public_path__ + "static/SiddhantSharma-2f8157789101b9379222a5809d918047.jpg";